<template>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('seteasybalance.loadmanagement')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconPowerManagement             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />

    <!--
    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>
    -->
    <SettingsPanel class="mt-24 sm:mt-28 mb-3 sm:mb-4">
      <template v-slot:formgrid>
          <div class="form-group mb-4">
            <SelectWithLabelIcon
                v-model="easybalancemode"
                :label="$t('seteasybalance.loadmanagement')"
                @update:modelValue ="onChange"
              >
              <template v-slot:options>
                <option value="0">{{ $t('common.off') }}</option>
                <option value="1">{{ $t('seteasybalance.static') }}</option>
                <option value="2">{{ $t('seteasybalance.dynamic') }}</option>
              </template>
            </SelectWithLabelIcon>
          </div>
          <div v-if="easybalancemode>0" class="form-group flex items-end">
            <div v-if="!this.isSpecialModbusSm" class="grow">
              <InputLabelError 
                v-model="powerglobal"
                :disabled="!easybalanceComputed"
                :label="easybalancemode==1 ? $t('seteasybalance.powerglobal') : $t('seteasybalance.powerglobaldyn')"
                :placeholder="easybalancemode==1 ? $t('seteasybalance.powerglobal') : $t('seteasybalance.powerglobaldyn')"
                validationType="number"
                :validator_off="!easybalanceComputed"
                @valid="(status) => valid_powerglobal = status"
                @update:modelValue ="onChange"
              />
            </div>
            <div v-else class="grow">
              <InputLabelError
                :label="$t('seteasybalance.powerglobal')"
                :disabled=true
                :placeholder="`${$t('seteasybalance.modbusControlled')} (Reg. ${this.sm_settings?.unitId >= 0 ? this.sm_settings.unitId : 1})`"
              />
            </div>

            <div class="flex-0 mb-4 ml-2"> 
              <ActionButton class="h-12" @click="optionmodal=true;">
                    <IconSetwheel             
                    class="inline-block lg:-mt-1 w-6 h-6"/>
                    <span class="ml-1 hidden lg:inline-block">{{ $t('seteasybalance.opt') }}</span>
              </ActionButton>
            </div>          
          </div>
          <div v-if="!editmode&&easybalancemode==1" class="form-group mb-0 sm:col-span-2">
              <div class="grid sm:grid-cols-1 gap-4">
                <PowerCard
                  icon="IconCars"
                  :title="$t('seteasybalance.chargingpark')"
                  :phases="true"
                  :power="chargingParkPower.total"
                  :phase1="chargingParkPower.L1"
                  :phase2="chargingParkPower.L2"
                  :phase3="chargingParkPower.L3"
                />
              </div>
          </div>

          <div v-if="!editmode&&easybalancemode==2" class="form-group mb-0 sm:col-span-2">
              <div class="grid sm:grid-cols-4 gap-4" :class="infoStatus?.smartmeterStatus=='connected' ? (this.isSpecialModbusSm ? 'sm:grid-cols-3':'sm:grid-cols-4'):'sm:grid-cols-3'">
                <PowerCard v-if="infoStatus?.smartmeterStatus=='connected' && this.isSpecialModbusSm==false"
                  icon="IconPowerGrid"
                  :title="$t('seteasybalance.grid')"

                  :power="(infoStatus?.powerGrid ?? 0) / 1000"
                />
                <PowerCard v-else-if="infoStatus?.smartmeterStatus=='connected'&&this.isSpecialModbusSm==true"
                  icon="IconPc"
                  :title="$t('seteasybalance.staticPowerLimit')"

                  :power="(infoStatus?.powerGrid ?? 0) / 1000"
                />
                <PowerCard v-else-if="infoStatus?.smartmeterStatus=='connecting'"
                  icon="IconSmartmeter"
                  :title="$t('seteasybalance.smartmeter')"
                  :txt="$t('common.connecting')"
                />                
                <PowerCard v-else-if="infoStatus?.smartmeterStatus=='disabled'"
                  icon="IconSmartmeter"
                  :title="$t('seteasybalance.smartmeter')"
                  :txt="$t('common.disabled')"
                />
                <PowerCard v-else-if="infoStatus?.smartmeterStatus=='disconnected'||infoStatus?.smartmeterStatus==''"
                  icon="IconSmartmeter"
                  :title="$t('seteasybalance.smartmeter')"
                  :txt="$t('common.disconnected')"
                />
                <PowerCard
                  v-else-if="(infoStatus?.smartmeterStatus ?? '').startsWith('error')"
                  icon="IconSmartmeter"
                  :title="$t('seteasybalance.smartmeter')"
                  :txt="$t(`setsolar.${infoStatus.smartmeterStatus}`)"
                />

                <PowerCard
                  icon="IconCars"
                  :title="$t('seteasybalance.chargingpark')"
                  :power="chargingParkPower.total"
                />
                <PowerCard v-if="infoStatus?.smartmeterStatus=='connected' && this.isSpecialModbusSm==false"
                  icon="IconFactory"
                  :title="$t('seteasybalance.remaining')"
                  :power="((infoStatus?.powerGrid ?? 0) / 1000)-chargingParkPower.total"
                />

                <ActionButton v-if="infoStatus && Object.keys(infoStatus).length" :color="infoStatus?.smartmeterStatus=='connected' ? 'blue':'red'" @click="backupSmSettings();smartmetermodal=true;">
                  <IconSetwheel             
                  class="inline-block mr-1 -mt-1 w-6 h-6"/>
                  {{ $t('seteasybalance.smartmeter') }}
                </ActionButton>


              </div>
          </div>


          
      </template>
      <template v-slot:formbottom>
          <ActionButton class="mt-4" v-if="dlmHasChanges || editmode || isDirty" :disabled="isLoading || (!dlmHasChanges && !isDirty)" @click="saveDlmSettings()">
            {{ $t('common.save') }}
          </ActionButton>
      </template>
    </SettingsPanel>

<div v-if="easybalancemode>0" class="px-2 sm:px-4 w-full max-w-5xl">
      <!--Tabellenkopf-->
      <div :class="[ editmode ? 'bg-skin-active128/5' : 'bg-skin-b-list-head' ]"
        class="flex items-center mx-0 mt-4 sm:mt-6 border-2 border-skin-b-list-bord rounded-t-xl">
        <!-- Linker Bereich: Buttons -->
        <div class="flex items-center md:w-auto">
          <ButtonHeaderIcon v-if="editmode&&(filteredClients.length!=editcount)"
            @click="MarkForAll(true);" class="" :options="[]">
            <IconRadioChecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="editmode&&(filteredClients.length==editcount)"
            @click="MarkForAll(false);" class="" :options="[]">
            <IconRadioUnchecked class="w-10 h-10" />
          </ButtonHeaderIcon>
          <ButtonHeaderIcon v-if="!editmode" tooltipText="" tooltipPosition="top-left"
          @click="stopPolling();editmode = !editmode;" class="" :options="[]">
            <!--<IconAddRfid class="w-12 h-12"/>-->
            <IconAdd class="w-10 h-10" />
          </ButtonHeaderIcon>

        </div>
        <!-- Mittlerer Bereich: Hauptbedienelemente -->
        <div class="flex-grow flex flex-col items-center w-full">
          <!-- Mittlerer Bereich: obere Zeile -->
          <div class="flex items-center border-b-2 w-full justify-between">
            <!-- 'ALLE AUSWÄHLEN' -->
            <ButtonHeader v-if="editmode&&(filteredClients.length!=editcount)"
              @click="MarkForAll(true);">
              <span class="sm:hidden">{{ $t('common.selectallmin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectall') }}</span>
            </ButtonHeader>
            <!-- 'KEINE AUSWÄHLEN' -->
            <ButtonHeader v-if="editmode&&(filteredClients.length==editcount)"
              @click="MarkForAll(false);">
              <span class="sm:hidden">{{ $t('common.selectnonemin') }}</span>
              <span class="hidden sm:inline-block">{{ $t('common.selectnone') }}</span>
            </ButtonHeader>
            <!-- 'Status XX ausgewählt' -->
            <span v-if="editmode&&editcount>0"
              class="bg-black/5 text-skin-b-list-base text-base px-3 py-0.5 rounded-full">
              <strong>{{ editcount }}</strong>
              <span class="hidden sm:inline-block">&nbsp;{{ $t('common.selected') }}</span>
            </span>
            <!-- 'ABBRRECHEN' -->
            <ButtonHeader v-if="editmode"
              @click="ResetMark();editmode = !editmode;startPolling();">
              {{ $t('common.cancel') }}
            </ButtonHeader>

            <!-- 'Status XX geregelt' -->
            <span  v-if="!editmode"
              class="bg-black/5 text-skin-b-list-base text-base px-3 py-0.5 rounded-full">
              <strong>{{ dlmcount }}</strong>
              <span class="hidden sm:inline-block">&nbsp;{{ $t('seteasybalance.controlledloadpoints', dlmcount ) }}</span>
            </span>
            <!-- 'BEARBEITEN' -->
            <ButtonHeader v-if="!editmode"
              @click="stopPolling();editmode = !editmode;">
              <span>
                <IconRadioChecked class="sm:mr-1 w-6 h-6 sm:hidden" />
              </span>
              <span class="hidden sm:block">{{ $t('common.edit') }}</span>
            </ButtonHeader>

          </div>
          <!-- Mittlerer Bereich: Untere Zeile -->
          <div class="w-full flex items-center justify-between">
            <!-- Mobile Sorting RFID -->
            <NavSelectWithIcon v-model="sortlist"
              class="w-full flex-shrink sm:hidden"
              :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'nameup', label: $t('common.nameuppercase')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'namedown', label: $t('common.nameuppercase')+' ('+$t('common.descending')+')', icon: 'IconSortDown', show: true },
                    { value: 'statusup', label: $t('common.status')+' ('+$t('common.ascending')+')', icon: 'IconSortUp', show: true },
                    { value: 'statusdown', label: $t('common.status')+' ('+$t('common.descending')+')', icon: 'IconSortDown' ,show: true }
                  ]">
            </NavSelectWithIcon>
            <!-- Normal Sorting RFID -->
            <div
              class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
              <button
                @click="if(this.sortlist=='nameup') this.sortlist='namedown'; else this.sortlist='nameup';"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.name') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="this.sortlist=='nameup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="this.sortlist=='namedown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!this.sortlist.includes('name')" />
              </button>
              
              <button
                @click="if(this.sortlist=='statusup') this.sortlist='statusdown'; else this.sortlist='statusup';"
                class="py-2 px-4 inline-flex text-skin-b-list-mute hover:text-skin-b-list-base focus:outline-none relative group uppercase">
                {{ $t('common.status') }}
                <IconSortUp class="ml-1 w-6 h-6" v-if="this.sortlist=='statusup'" />
                <IconSortDown class="ml-1 w-6 h-6" v-if="this.sortlist=='statusdown'" />
                <IconSort class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100"
                  v-if="!this.sortlist.includes('status')" />
              </button>
              <!-- 
              <button @click="this.filterblocked=!this.filterblocked;filterpicker(this.filterboxid);"
                class="py-2 px-4 inline-flex text-skin-b-list-mute cursor-pointer focus:outline-none relative group uppercase">
                {{ $t('pairing.deactive') }}
                <IconRadioChecked class="ml-1 w-6 h-6" v-if="this.filterblocked" />
                <IconRadioUnchecked class="ml-1 w-6 h-6 opacity-0 group-hover:opacity-100" v-if="!this.filterblocked" />
              </button>

              <div class="hidden md:flex items-center w-48 text-skin-b-list-mute">
                <IconSearch v-if="searchfilter==''" @click="this.$refs.SearchFilterInput.focus();"
                  class="w-6 h-6 mr-1 hover:cursor-pointer flex-none" />
                <IconClose v-else
                  @click="this.searchfilter='';filterpicker(this.filterboxid);this.$refs.SearchFilterInput.focus();"
                  class="h-6 w-6 mr-1 hover:cursor-pointer flex-none" />
                <input class="shrink md:flex-1 w-full px-2 py-1 appearance-none 
                                  text-base leading-tight border-0 rounded
                                  bg-slate-300/20 focus:bg-slate-300/30
                                  focus:outline-none focus:ring-0"
                  :class="[ this.searchfilter=='' ? 'bg-slate-300/20 font-normal' : 'bg-slate-300/30 font-bold' ]"
                  type="text" ref="SearchFilterInput" :placeholder="$t('common.searchuppercase')" v-model="searchfilter"
                  @input="filterpicker(this.filterboxid);">
              </div> -->

            </div>

<!--
            <NavEditWithIcon v-if="editmode&&dlmClientsTemp.length>0"
              v-model="multieditselector" class="w-full flex-shrink" :placeholder="$t('common.pleaseselect')" :options="[
                    { value: 'delete', label: $t('common.delete'), icon: 'delete', color:'red', show: true,
                      onClick: () => { deletemodal=true; }
                     },
                    { value: 'lock', label: $t('common.block'), icon: 'block', color:'red', show: true,
                      onClick: () => { switchstatus('multi','disabled'); }
                     },
                    { value: 'unlock', label: $t('common.activate'), icon: 'check', color:'green', show: true,
                      onClick: () => { switchstatus('multi','active'); }
                     },
                    { value: 'type', label: $t('common.changetype'), icon: 'stacks', show: true,
                      onClick: () => { multieditmodal=true; }
                     },
                    { value: 'color', label: $t('common.changecolor'), icon: 'color', show: true,
                      onClick: () => { multicolormodal=true; }
                     },
                  ]">
            </NavEditWithIcon>

            
                <div v-if="editmode.status&&editmode.tokenlist.length>0" class="hidden sm:flex flex-wrap md:flex-nowrap items-center">
                  <ButtonHeader
                    @click="deletemodal=true;"
                  >
                    <span><IconDelete class="sm:mr-1 w-6 h-6"/></span>
                    <span class="hidden sm:block">{{ $t('common.delete') }}</span>
                  </ButtonHeader>
                </div>
                -->
            <div v-if="filteredClients.length > 0" class="flex-auto my-auto text-right">
              <h4 class="py-2 px-4 text-skin-b-list-mute">
                <span><strong>{{ filteredClients.length }}</strong>&nbsp;{{ $t('seteasybalance.loadpoint', filteredClients.length ) }}</span>
              </h4>
            </div>
          </div>
        </div>

      </div>
      <!--Tabellenkopf Ende-->

      <ListDynamicDiv>
        <ListBody :items="filteredClients" itemKey="serial" :isLoading="isLoading">
          <template #item="{ item }">

            <ListItemDlm
              @listclick="editmode && (item.isDLM = !item.isDLM, MarkForDlm(item.isDLM, item.serial))"
              :itemdata="item" :editmode="editmode" :buttonsvisible="false">
            </ListItemDlm>

          </template>
        </ListBody>
      </ListDynamicDiv>
      <!-- Modal for Smartmeter -->
      <MultiModal :show="smartmetermodal" @close="restoreSmSettings();smartmetermodal=false;">
        <template #header>
          {{ $t('seteasybalance.smartmeter') }}
        </template>
        <div>
          <div class="mb-4">
          <SelectWithLabelIcon
              v-model.number="sm_settings.id"
              :label="$t('setsolar.installedsm')"
              :placeholder="$t('setsolar.installedsm')"
              @update:modelValue="onSmartmeterChange"
            >
            <template v-slot:options>
              <option v-for="(smartmeter, index) in smartmeterList" :key="index" :value="smartmeter.id">
                <span v-if="smartmeter.supplier!=''">
                  {{smartmeter.supplier}}&nbsp;-&nbsp;
                </span>                    
                {{smartmeter.name}}
              </option>
            </template>
          </SelectWithLabelIcon>
          </div>
          <div class="mb-4" v-if="sm_settings.id !== 15">
          <ToggleWithLabel
            v-model="smartmeterinvertBool"
            :label="$t('setsolar.invertsm')"
            :ontext="$t('common.yes')"
            :offtext="$t('common.no')"
          />
          </div>
          <div class="mb-4" v-if="sm_settings.id !== 12">
          <InputLabelError
            v-model="sm_settings.ip"
            :label="$t('setsolar.ipadresssm')"
            :placeholder="$t('setsolar.ipadresssmph')"
            validationType="ip"
            :validator_off="!smartmetermodal"
            @valid="(status) => valid_smip = status"
          />
          </div>
          <div class="mb-4" v-if="sm_settings.id !== 12">
          <InputLabelError
            v-model.number="sm_settings.port"
            :label="$t('setsolar.portsm')"
            :placeholder="$t('setsolar.portsmph')"
            validationType="number"
            :validator_off="!smartmetermodal"
            @valid="(status) => valid_smport = status"
          />
          </div>
          <div class="mb-4" v-if="sm_settings.id !== 12 && sm_settings.id !== 15">
          <ToggleWithLabel
            v-model="unitidauto"
            :label="$t('setsolar.unitidauto')"
            :ontext="$t('common.yes')"
            :offtext="$t('common.no')"
          />
          </div>
          <div v-if="sm_settings.id !== 12">
          <InputLabelError
            v-if="!unitidauto"
            v-model.number="sm_settings.unitId"
            :label="sm_settings.id == 15 ? $t('seteasybalance.modbusRegister') + ' (0-65534, UINT32)' : $t('setsolar.unitidsm')"

            :placeholder="sm_settings.id == 15 ? '0-65534' : $t('setsolar.unitidsm')"
            validationType="number"
            :validator_off="!smartmetermodal"
            @valid="(status) => valid_unitid = status"
          />  
        </div>

        </div>
        <template #footer>
          <ActionButton @click="restoreSmSettings();smartmetermodal=false;">
            {{ $t('common.cancel') }}
          </ActionButton>
          <ActionButton :disabled="!validsm_settings" @click="saveDlmSettings();smartmetermodal=false;">
            {{ $t('common.save') }}
          </ActionButton>          
        </template>
      </MultiModal>
      <!-- Modal for Smartmeter -->
      <MultiModal :show="optionmodal" @close="optionmodal=false;">
        <template #header>
          {{ $t('seteasybalance.options') }}
        </template>
        <div>
          <div class="mb-4">
          <SelectWithLabelIcon
              v-model.number="minCurrentEV"
              :label="$t('seteasybalance.mincurrentev')"
              :placeholder="$t('seteasybalance.mincurrentev')"
              @update:modelValue ="onChange"
            >
            <template v-slot:options>
              <option
                v-for="value in Array.from({ length: 11 }, (_, i) => i + 6)"
                :key="value"
                :value="value"
              >
                {{ $t('seteasybalance.ampere', { ampere: value }) }}
              </option>
            </template>
          </SelectWithLabelIcon>
          </div>
          <div class="mb-4">
          <SelectWithLabelIcon
              v-model.number="timeoutCurrent"
              :label="$t('seteasybalance.timeoutcurrent')"
              :placeholder="$t('seteasybalance.timeoutcurrent')"
              @update:modelValue ="onChange"
            >
            <template v-slot:options>
              <option :value=0>{{ $t('seteasybalance.timeoutcurrentzero') }}</option>
              <option
                v-for="value in Array.from({ length: 11 }, (_, i) => i + 6)"
                :key="value"
                :value="value"
              >
                {{ $t('seteasybalance.ampere', { ampere: value }) }}
              </option>
            </template>
          </SelectWithLabelIcon>

          </div>
        </div>
        <template #footer>
          <ActionButton @click="optionmodal=false;">
            {{ $t('common.close') }}
          </ActionButton>
          <!-- <ActionButton @click="saveDlmSettings();optionmodal=false;">
            {{ $t('common.save') }}
          </ActionButton>           -->
        </template>
      </MultiModal>
    <!-- Check for Values  
        <p>sm_settings: {{ sm_settings }}</p><br>
    <p>infoStatus: {{ infoStatus }}</p><br>
    <p>Config: {{ dlmsettings }}</p><br>
    <p>this.dlmClientsTemp: {{ dlmClientsTemp }}</p><br>
    <p>this.dlmClients: {{ dlmClients }}</p><br>
          <p>this.allClients: {{ allClients }}</p><br>
    <p>this.dlmStatus: {{ dlmStatus }}</p><br>      

    --> 
</div>

</SrcBackgroundScroll>
</template>

<script>
import IconAdd from './icons/IconAdd.vue'
import IconSort from './icons/IconSort.vue'
import IconSortUp from './icons/IconSortUp.vue'
import IconSortDown from './icons/IconSortDown.vue'
import IconRadioChecked from './icons/IconRadioChecked.vue'
import IconRadioUnchecked from './icons/IconRadioUnchecked.vue'
import IconSetwheel from './icons/IconSetwheel.vue'
//import IconFactory from './icons/IconFactory.vue'
//import IconCars from './icons/IconCars.vue'

//import BlueButton from './sources/SrcBlueButton.vue'
//import RedButton from './sources/SrcRedButton.vue'

import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconPowerManagement from './icons/IconPowerManagement.vue'
import SettingsPanel from './elements/SettingsPanel.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import MultiModal from './elements/MultiModal.vue'
import ListDynamicDiv from './elements/ListDynamicDiv.vue'
import ListBody from './elements/ListBody.vue'
import ListItemDlm from './elements/ListItemDlm.vue'
import PowerCard from './elements/PowerCard.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import NavSelectWithIcon from './elements/NavSelectWithIcon.vue'
import ButtonHeader from './elements/ButtonHeaderTooltip.vue'
import ButtonHeaderIcon from './elements/ButtonHeaderIconTooltip.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'

import { useI18n } from 'vue-i18n'
const TOKEN_EXPIRED = 'token';
const RESPONSE_OK = 'ok';
//const NO_CONNECTION_STATUS = 'no_connection';

export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },
  components: {
    IconAdd, IconSetwheel, MultiModal, ToggleWithLabel,
    IconSort, IconSortUp, IconSortDown, IconRadioChecked, IconRadioUnchecked,
      SrcBackgroundScroll, HeadlineSubScroll, IconPowerManagement,
      SettingsPanel, ActionButton,
      InputLabelError,
      ListDynamicDiv, ListBody, ListItemDlm, PowerCard,
    ButtonHeaderIcon, ButtonHeader,  NavSelectWithIcon, SelectWithLabelIcon, ConfirmLeaveModal
    }, 
  data() {
    return {
          isLoading: false,
          saveto: this.$store.state.WbId,
          easybalance: false,
          easybalancemode: 0,
          powerglobal: 0,
          minCurrentEV: 0,
          timeoutCurrent: 0,
          valid_powerglobal: false,
          dlmsettings: [],
          sm_settings: [],
          sm_settings_org: [],
          allClients: [],
          dlmClients: [],
          dlmClientsTemp: [],
          dlmStatus: [],
          smartmeterList: [],
          infoStatus: {},
          pollingInterval: null,
          editmode: false,
          sortlist: this.$store.state.SortListDlm,
          optionmodal: false,
          smartmetermodal: false,
          valid_smip: false,
          valid_smport: false,
          valid_unitid: false,
          isShrunk: false,
          

          isDirty:false,
          showLeaveDialog:false
       }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
    dlmHasChanges() {
      // Only require power validation when load mgmt is enabled
      const powerValidationRequired = this.easybalanceComputed;
      const powerValidGate = powerValidationRequired ? this.valid_powerglobal : true;
      if (!powerValidGate && !this.isSpecialModbusSm) return false;
      const settings = this.dlmsettings ?? {};
      const config = settings.config ?? {};

      const serverMode = Number(settings.enabled ?? 0);
      const localMode  = Number(this.easybalancemode ?? 0);

      const maxPowerServer = Number(config.maxPower/1000 ?? 0);
      const maxPowerLocal = Number(this.powerglobal ?? 0);

      // differences
      const enabledDiff = serverMode !== localMode;
      const powerDiff = Math.abs(maxPowerServer - maxPowerLocal) > 0.001;

      // compare clients (by serial)
      const toKey = arr => (Array.isArray(arr) ? arr.map(x => String(x.serial).trim()).sort().join('|') : '');
      const clientsDiff = toKey(this.dlmClients) !== toKey(this.dlmClientsTemp);

      return (enabledDiff || powerDiff || clientsDiff);
    },
    validsm_settings() {
        let hasValidIp = this.valid_smip;
        let hasValidPort = this.valid_smport;
        let hasValidUnitid = this.valid_unitid;
        // unitId must be 0–255
        const unitId = this.sm_settings.unitId;
        let unitIdIsValid = (unitId >= 0 && unitId <= 255) || unitId ==-2;
        if(unitId==-2) hasValidUnitid=true;
        // id must be > 0
        if(this.sm_settings.id == 15 && unitId >= 0){
          hasValidUnitid=true;
          unitIdIsValid=true;
        }
        const id = this.sm_settings.id;
        const idIsValid = Number.isInteger(id) && id > 0;
        if(id===12){
          hasValidIp = true;
          hasValidPort = true;
          hasValidUnitid = true;
          unitIdIsValid = true;
        }
        //console.log(idIsValid,hasValidIp,hasValidPort,hasValidUnitid,unitIdIsValid);
        return (
            hasValidIp &&
            hasValidPort &&
            hasValidUnitid &&
            unitIdIsValid &&
            idIsValid
        );
    },
    filteredClients() {
      const clients = Array.isArray(this.allClients) ? this.allClients : [];

      // editmode → zeige alle Clients
      let result = this.editmode
        ? clients
        : clients.filter(client => client?.isDLM === true);

      // ---------------------
      // Name Sorting
      // ---------------------
      if (this.sortlist === 'nameup') {
        result = result.slice().sort((a, b) =>
          String(a?.name ?? '').localeCompare(String(b?.name ?? ''), 'de', { sensitivity: 'base' })
        );
      }

      if (this.sortlist === 'namedown') {
        result = result.slice().sort((a, b) =>
          String(b?.name ?? '').localeCompare(String(a?.name ?? ''), 'de', { sensitivity: 'base' })
        );
      }

      // ---------------------
      // Status Sorting
      // ---------------------

      const STATUS_ORDER = {
        'loading': 0,
        'loading_paused': 1,
        'loading_done': 2,
        'wait_unlock': 3,
        'auth_ok': 4,
        'connected': 5,     
        'loading_planned': 7,
        'idle': 8,
        '': 9,
        'unknown': 10,
        'booting': 11,
        'no_connection': 12,        
        'error': 13,
      };

      const getStatusRank = status => STATUS_ORDER[status] ?? -1;

      if (this.sortlist === 'statusup') {
        // schlecht → gut
        result = result.slice().sort((a, b) =>
          getStatusRank(a?.wallboxStatus) - getStatusRank(b?.wallboxStatus)
        );
      }

      if (this.sortlist === 'statusdown') {
        // gut → schlecht
        result = result.slice().sort((a, b) =>
          getStatusRank(b?.wallboxStatus) - getStatusRank(a?.wallboxStatus)
        );
      }

      return result;
    },
    smartmeterinvertBool: {
      get() {
        return this.sm_settings.invers === 1
      },
      set(val) {
        this.sm_settings.invers = val ? 1 : 0
      }
    },
    unitidauto: {
      get() {
        // <0 bedeutet Auto
        return this.sm_settings.unitId === -2;
      },
      set(val) {
        if (val === true) {
          // Auto: unitId zurück auf 0
          this.sm_settings.unitId = -2;
        } else {
          // Manuell: unitId darf nicht 0 sein → Minimum 1
          if (this.sm_settings.unitId === -2) {
            this.sm_settings.unitId = 0;
          }
        }
      }
    },
    editcount() {
      return this.dlmClientsTemp?.length ?? 0;
    },
    dlmcount() {
      return this.dlmClients?.length ?? 0;
    },
    easybalanceComputed() {
      return Number(this.easybalancemode) > 0
    },
    chargingParkPower() {
      const w = this.filteredClients.reduce(
        (acc, client) => {
          const dlm = client?.dlm ?? {};
          acc.total += Number(dlm.totalPower ?? 0);
          acc.L1    += Number(dlm.powerL1 ?? 0);
          acc.L2    += Number(dlm.powerL2 ?? 0);
          acc.L3    += Number(dlm.powerL3 ?? 0);
          return acc;
        },
        { total: 0, L1: 0, L2: 0, L3: 0 }
      );

      return {
        total: w.total,
        L1: w.L1 / 1000000,
        L2: w.L2 / 1000000,
        L3: w.L3 / 1000000
      };
    },
    isSpecialModbusSm(){
      if(this.sm_settings?.id == 15 && this.easybalancemode == 2)
        return true;
      return false;
    }
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},

    backupSmSettings(){
      this.sm_settings_org = {...this.sm_settings};
    },
    restoreSmSettings(){
      this.sm_settings = {...this.sm_settings_org};
    },

    onSmartmeterChange(){
      console.log(this.sm_settings.id);  
      if(this.sm_settings.id == 15){
        if(this.sm_settings.unitId < 0)
          this.sm_settings.unitId = 0;
        this.sm_settings.invers = 0;
      }else{
        if(this.sm_settings.unitId > 255)
          this.sm_settings.unitId = 0;
      }

    },

    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
    },
    ResetMark() {
      this.dlmClientsTemp = [...this.dlmClients]; // {serial: 'xxxxxxxx'}, {serial: 'xxxxxxxx'}
      // Setze den isDLM-Status für jedes gefilterte Element
      this.allClients.forEach(entry => {
        entry.isDLM = this.dlmClients.some(client => client.serial === entry.serial);
      });
    },
    MarkForAll(selectAll) {
        // Wenn `selectAll` true ist, füge alle Serials hinzu Format {serial: 'xxxxxxxx'}
        if (selectAll) {
          this.dlmClientsTemp = this.filteredClients.map(entry => ({ serial: entry.serial }));
        } else {
          // Wenn `selectAll` false ist, leere die Liste
          this.dlmClientsTemp = [];
        }
        // Checkbox-Status für alle Einträge aktualisieren
        this.filteredClients.forEach(entry => {
          entry.isDLM = selectAll;
        });
    },
    MarkForDlm(checked, serialnr) {
      if (checked) {
        // Add only if not already in the list
        const exists = this.dlmClientsTemp.some(item => item.serial === serialnr);
        if (!exists) {
          this.dlmClientsTemp.push({ serial: serialnr });
        }
      } else {
        // Remove if it exists
        const index = this.dlmClientsTemp.findIndex(item => item.serial === serialnr);
        if (index > -1) {
          this.dlmClientsTemp.splice(index, 1);
        }
      }
    },
    async saveDlmSettings() {
      try {
        this.isLoading = true;

        const token = this.$store?.state?.token ?? '';

        // --- Enabled / Mode ---
        const enabled = Number(this.easybalancemode ?? 0);

        // --- Aktuelle Konfiguration aus dlmsettings übernehmen ---
        const currentConfig = this.dlmsettings?.config ?? {};
        currentConfig.smartmeter = this.sm_settings ?? {};
        // Sicherstellen, dass wir ein eigenständiges Objekt bekommen (kein Proxy)
        const configObj = JSON.parse(JSON.stringify(currentConfig));

        // --- maxPower im Config-Objekt anpassen (Server erwartet Watt) ---
        configObj.maxPower = Math.round(Number(this.powerglobal*1000 ?? 0));
        configObj.minCurrentEv = Math.round(Number(this.minCurrentEV*1000 ?? 0));
        configObj.timeoutCurrent = Math.round(Number(this.timeoutCurrent*1000 ?? 0));

        // --- Clients aus der aktuellen Arbeitskopie (Temp-Liste) ---
        const clientsObj = {
          clients: (Array.isArray(this.dlmClientsTemp) ? this.dlmClientsTemp : [])
            .map(c => ({ serial: String(c.serial ?? '').trim() }))
            .filter(c => c.serial.length > 0)
        };

        // --- URL zusammenbauen ---
        const url =
          `wallbox/dlm.php?action=sync_dlm_master_settings` +
          `&dlmEnabled=${encodeURIComponent(enabled)}` +
          `&dlmConfig=${encodeURIComponent(JSON.stringify(configObj))}` +
          `&dlmClients=${encodeURIComponent(JSON.stringify(clientsObj))}` +
          `&user=${encodeURIComponent(token)}`;

        //console.log('🔄 Sende DLM-Konfiguration:', url);

        // --- Anfrage ausführen ---
        const response = await this.axios.get(url);
        const data = response?.data;

        if (data?.status === 'ok') {
          //console.log('✅ DLM-Einstellungen erfolgreich gespeichert');

          // Snapshot übernehmen (Server ist jetzt synchron)
          this.dlmClients = [...this.dlmClientsTemp];
          //this.setIsDLMFrom(this.dlmClients);
          this.editmode = false;
        } else if (data?.status === 'token') {
          console.warn('⚠️ Token abgelaufen – Redirect');
          this.$router.push({ path: '/' });
        } else {
          console.error('❌ Fehler beim Speichern der DLM-Settings:', data);
        }
      } catch (err) {
        console.error('❌ saveDlmSettings() Fehler:', err);
      } finally {
        //this.isLoading = false;
        //this.startPolling();
        this.isDirty = false;
        this.loadDlmData();
      }
    },
    mergeDlmStatus() {
      if (!Array.isArray(this.allClients) || !Array.isArray(this.dlmStatus)) return;

      // Create lookup table for fast access
      const statusMap = new Map(this.dlmStatus.map(s => [Number(s.client), s]));

      // Helper to safely sum numeric values
      const toNum = v => (Number.isFinite(Number(v)) ? Number(v) : 0);

      this.allClients = this.allClients.map(client => {
        const s = statusMap.get(Number(client.id));
        if (!s) return { ...client, dlm: null };

        // Sum the three phases into totalPower (same unit as inputs — likely milliwatts)
        const totalPower = (toNum(s.powerL1) + toNum(s.powerL2) + toNum(s.powerL3)) / 1e6;

        return {
          ...client,
          dlm: {
            ...s,
            totalPower,
          },
        };
      });
    },
    startPolling() {
      // clear any old interval just in case
      this.stopPolling();

      this.pollingInterval = setInterval(async () => {
        try {
          const token = this.$store?.state?.token ?? '';
          const wbId  = this.$store?.state?.WbId ?? '-1';

          const allClientsUrl  = `wallbox/client.php?action=reload_clients&user=${encodeURIComponent(token)}`;
          const dlmStatusUrl   = `wallbox/dlm.php?action=dlm_reload_status&user=${encodeURIComponent(token)}`;
          const infoStatusUrl   = `wallbox/info.php?action=get_status&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;

          // Parallel requests for speed
          const [allClientsResult, dlmStatusResult, infoStatusResult] = await Promise.allSettled([
            this.axios.get(allClientsUrl),
            this.axios.get(dlmStatusUrl),
            this.axios.get(infoStatusUrl),
          ]);

          // --- Update clients ---
          if (allClientsResult.status === 'fulfilled') {
            this.processClients(allClientsResult.value?.data);
          } else {
            console.error('Polling clients failed:', allClientsResult.reason);
          }

          // --- Update DLM Status ---
          if (dlmStatusResult.status === 'fulfilled') {
            const { data } = dlmStatusResult.value || {};
            const status = data?.status;
            if (status === 'ok') {
              this.dlmStatus = Array.isArray(data?.tbl_remote_dlm_status)
                ? data.tbl_remote_dlm_status
                : [];
            }
          } else {
            console.error('Polling DLM status failed:', dlmStatusResult.reason);
          }

          // --- Update Info Status ---
          if (infoStatusResult.status === 'fulfilled') {
            const { data } = infoStatusResult.value || {};
            const status = data?.status;
            if (status === 'ok') {
              this.infoStatus = data.tbl_status;
            }
          } else {
            console.error('Polling info status failed:', infoStatusResult.reason);
          }

          // --- Merge updates ---
          this.mergeDlmStatus();

        } catch (err) {
          console.error('Polling error:', err);
        }
      }, 2000); // every 2 seconds
    },

    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    async loadDlmData() {
      this.isLoading = true;
      try {
        const token = this.$store?.state?.token ?? '';
        const wbId  = this.$store?.state?.WbId ?? '';

        const dlmSettingsUrl = `wallbox/dlm.php?action=get_dlm_master_settings&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;
        const allClientsUrl  = `wallbox/client.php?action=reload_clients&user=${encodeURIComponent(token)}`;
        const dlmStatusurl = `wallbox/dlm.php?action=dlm_reload_status&user=${encodeURIComponent(token)}`;
        const smartmeterListUrl = `wallbox/info.php?action=get_smartmeter&user=${encodeURIComponent(token)}&client=${encodeURIComponent(wbId)}`;

        const [dlmSettingsResult, allClientsResult, dlmStatusResult, smartmeterListResult] = await Promise.allSettled([
          this.axios.get(dlmSettingsUrl),
          this.axios.get(allClientsUrl),
          this.axios.get(dlmStatusurl),
          this.axios.get(smartmeterListUrl),
        ]);

        // --- DLM settings ---
        if (dlmSettingsResult.status === 'fulfilled') {
          const { data } = dlmSettingsResult.value || {};
          const status = data?.status;

          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            const master = data?.tbl_dlm_master ?? {};

            // normalize enabled -> boolean
            const enabledRaw = Number(master?.enabled ?? 0);
            const enabledNum = Number.isFinite(enabledRaw) ? enabledRaw : 0;

            //const enabled = enabledNum > 0; // true, wenn 1 oder 2
            const mode = enabledNum;  

            // normalize power -> kW number
            this.powerglobal = Number.isFinite(+master?.config?.maxPower)
              ? master.config.maxPower / 1000
              : null;
            // normalize minpower -> kW number
            this.minCurrentEV =  Number.isFinite(+master?.config?.minCurrentEv)
              ? master.config.minCurrentEv / 1000
              : 8;

            this.timeoutCurrent =  Number.isFinite(+master?.config?.timeoutCurrent)
              ? master.config.timeoutCurrent / 1000
              : 2;

            this.dlmsettings = master;
            this.sm_settings = master.config.smartmeter;
            this.easybalancemode = mode;
            this.dlmClients  = master?.clients?.clients ?? [];
            this.dlmClientsTemp = [...this.dlmClients];

          } else {
            console.error('Error loading DLM settings:', data);
          }
        } else {
          console.error('DLM settings request failed:', dlmSettingsResult.reason);
        }

        // --- Clients ---
        if (allClientsResult.status === 'fulfilled') {
          this.processClients(allClientsResult.value?.data);
        } else {
          console.error('Clients request failed:', allClientsResult.reason);
        }

        // --- DLM Status ---
        if (dlmStatusResult.status === 'fulfilled') {
          const { data } = dlmStatusResult.value || {};
          const status = data?.status;
          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            this.dlmStatus = Array.isArray(data?.tbl_remote_dlm_status)
              ? data.tbl_remote_dlm_status
              : [];
          }

        } else {
          console.error('dlmStatus request failed:', dlmStatusResult.reason);
        }

        // --- Smartmeter List ---
        if (smartmeterListResult.status === 'fulfilled') {
          const { data } = smartmeterListResult.value || {};
          const status = data?.status;
          if (status === TOKEN_EXPIRED) {
            this.$router.push({ path: '/' });
            return; // stop after redirect
          }

          if (status === RESPONSE_OK) {
            this.smartmeterList = Array.isArray(data?.tbl_smartmeter)
              ? data.tbl_smartmeter.sort((a,b) => a.alphaOrder - b.alphaOrder)
              : [];
            this.smartmeterList.forEach(item => {
                if(item.name=='SunSpec'){
                  item.name=this.$t('setsolar.sunspec');
                }
                item.name = this.decodeHtml(item.name);
                item.supplier = this.decodeHtml(item.supplier);
              });
          }

        } else {
          console.error('smartmeter List request failed:', smartmeterListResult.reason);
        }

        this.mergeDlmStatus();

      } catch (error) {
        console.error('Error loading DLM data:', error);
      } finally {
        this.isLoading = false;
        this.startPolling();
      }
    },
    processClients(data) {
      const status = data?.status;

      if (status === TOKEN_EXPIRED) {
        this.$router.push({ path: '/' });
        return;
      }

      if (status === RESPONSE_OK) {
        const safeNum = v => Number.isFinite(Number(v)) ? Number(v) : -Infinity;

        this.allClients = (data?.tbl_clients ?? [])
          .map(client => ({
            ...client,
            name: this.decodeHtml?.(client?.name ?? '') ?? (client?.name ?? ''),
            info: this.decodeHtml?.(client?.info ?? '') ?? (client?.info ?? ''),
            isDLM: this.dlmClients.some(c => c.serial === client.serial), // default; will be overwritten in updateIsDLM
          }))
          // sort: groupId desc, then idx asc; tolerate missing values
          .sort((a, b) => {
            const g = safeNum(b?.groupId) - safeNum(a?.groupId);
            if (g !== 0) return g;
            return safeNum(a?.idx) - safeNum(b?.idx);
          });
      } else {
        console.error('Error fetching clients data:', data);
      }
    },
  },
  beforeUnmount() {
    this.stopPolling();
    this.$store.commit('setSortListDlm', this.sortlist);
  },
  created() {  
      this.isLoading = true;
      this.loadDlmData();
  },
};
</script>

<style scoped>
</style>
